import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M12 14.8571L18 20V6C18 4.89543 17.1046 4 16 4H8C6.89543 4 6 4.89543 6 6V20L12 14.8571ZM8 15.6516L12 12.223L16 15.6516V6H8V15.6516Z"
    fillRule="evenodd"
  />,
  'BookmarkIcon',
)
